import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import "./sass/variables.scss";

Vue.config.productionTip = false;

const fixIdScrolling = {
	watch: {
		$route() {
			const currentRoute = this.$router.currentRoute;
			const idToScrollTo = currentRoute.hash;
			this.$nextTick(() => {
				if (idToScrollTo && document.querySelector(idToScrollTo)) {
					document.querySelector(idToScrollTo).scrollIntoView();
				}
			});
		},
	},
};

new Vue({
  mixins: [fixIdScrolling],
	el: '#app',
	router,
	vuetify,
	components: { App },
	render: h => h(App),
});
